module.exports = __webpack_public_path__ + "static/media/24presupuesto.887f8a6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/24presupuesto.mp4
// module id = 727
// module chunks = 1